export default __webpack_public_path__ + "static/103468-f20ead1b3d7bb1e3a5e6e539e095e22a.jpg";